import { computed } from "vue";
import type { IYaSlotConfig, IYaSlotProps } from "@magnit/core/src/containers/VYaSlot/VYaSlot.types";
import { ProductCatalogType, useContentStore } from "~/store/content";
import { useCategoriesStore } from "~/store/categories";

const YA_SLOT_CONFIG_DEFAULT: IYaSlotConfig = {
  id: "adfox_169450654782591128",
  p1: "czkwo",
  p2: "htnq",
  pfc: "fgigq",
};

const YA_SLOT_CONFIG_DEFAULT_NEW_ARRIVAL: IYaSlotConfig = {
  id: "adfox_169450697750634329",
  p1: "czkov",
  p2: "htnq",
  pfc: "fgign",
};

const useCatalogYaSlotConfig = () => {
  const route = useRoute();
  const contentStore = useContentStore();
  const categoriesStore = useCategoriesStore();
  const { adfoxOwnerId } = usePublicConfig();

  const getYaSlotConfig = (config: typeof YA_SLOT_CONFIG_DEFAULT): IYaSlotProps => ({
    ownerId: adfoxOwnerId.value,
    config,
    placeholderImageSrc: SLOT_PLACEHOLDER_IMAGE_SRC,
    placeholderUrl: SLOT_PLACEHOLDER_URL,
  });

  const yaSlotConfigDefault = getYaSlotConfig(YA_SLOT_CONFIG_DEFAULT);
  const yaSlotConfigDefaultNewArrival = getYaSlotConfig(YA_SLOT_CONFIG_DEFAULT_NEW_ARRIVAL);

  if (contentStore.status.newArrival !== "success") {
    contentStore.requestNewArrival();
  }

  const newArrivalChildrenIds = computed(() =>
    contentStore.newArrival?.categoryId
      ? categoriesStore
          .getChildrenById(
            contentStore.newArrival.categoryId.toString(),
            contentStore.newArrival?.categoryType ===
            ProductCatalogType.Main
              ? "goods"
              : "promo",
          )
          .map((i) => i.id)
      : [],
  );

  const yaSlotConfig = computed<IYaSlotProps>(() => {
    const isMainCatalog =
      contentStore.newArrival?.categoryType ===
      ProductCatalogType.Main;

    switch (route.name) {
      case "catalog":
        return isMainCatalog && !contentStore.newArrival?.categoryId
          ? yaSlotConfigDefaultNewArrival
          : yaSlotConfigDefault;
      case "catalog-category-slug":
        return isMainCatalog &&
          newArrivalChildrenIds.value.includes(route.params.category as string)
          ? yaSlotConfigDefaultNewArrival
          : yaSlotConfigDefault;
      case "promo-catalog":
        return !isMainCatalog && !contentStore.newArrival?.categoryId
          ? yaSlotConfigDefaultNewArrival
          : yaSlotConfigDefault;
      case "promo-catalog-category-categorySlug":
        return !isMainCatalog &&
          newArrivalChildrenIds.value.includes(route.params.category as string)
          ? yaSlotConfigDefaultNewArrival
          : yaSlotConfigDefault;
      default:
        return yaSlotConfigDefault;
    }
  });

  return {
    yaSlotConfig,
  };
};

export default useCatalogYaSlotConfig;
